export enum CompleteBookingStep {
  COMPLETE_BOOKING = 'COMPLETE_BOOKING',
  TRAVEL_CLAIMS = 'TRAVEL_CLAIMS',
  CASE_NOTE = 'CASE_NOTE',
}
